var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.334 28.666l7.4-2.844c0.472-0.182 0.708-0.274 0.93-0.392 0.196-0.106 0.384-0.228 0.56-0.366 0.2-0.154 0.378-0.332 0.736-0.69l15.040-15.040c0.703-0.686 1.138-1.642 1.138-2.7 0-2.083-1.689-3.772-3.772-3.772-1.058 0-2.014 0.436-2.699 1.137l-15.041 15.041c-0.358 0.36-0.536 0.538-0.69 0.736-0.138 0.176-0.26 0.364-0.366 0.56-0.118 0.22-0.208 0.46-0.39 0.932l-2.846 7.4zM3.334 28.666l2.744-7.134c0.196-0.51 0.294-0.766 0.462-0.882 0.106-0.075 0.238-0.12 0.381-0.12 0.044 0 0.087 0.004 0.129 0.012l-0.004-0.001c0.2 0.040 0.394 0.232 0.78 0.62l3.014 3.010c0.386 0.388 0.58 0.58 0.618 0.782 0.008 0.038 0.012 0.081 0.012 0.125 0 0.143-0.045 0.275-0.121 0.383l0.001-0.002c-0.116 0.168-0.372 0.266-0.882 0.462l-7.134 2.744z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.4286,
    d: "M33.525 2.286h-30.478l12.192 14.416v9.966l6.094 3.047v-13.013l12.192-14.416z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#current",
    style: {
      stroke: "var(--color2, #current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M12.472 28c0.94 0.83 2.176 1.334 3.528 1.334s2.588-0.504 3.528-1.334M24 10.666c0-4.418-3.582-8-8-8s-8 3.582-8 8v0c0 4.12-1.040 6.942-2.2 8.808-0.98 1.574-1.47 2.36-1.452 2.58 0.020 0.244 0.072 0.336 0.268 0.48 0.176 0.132 0.974 0.132 2.57 0.132h17.628c1.596 0 2.394 0 2.57-0.13 0.196-0.146 0.248-0.24 0.268-0.48 0.018-0.22-0.472-1.008-1.452-2.582-1.16-1.866-2.2-4.686-2.2-8.808z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-circle-broken-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4.45 9.334c2.348-4.014 6.638-6.667 11.548-6.667 7.364 0 13.334 5.97 13.334 13.334s-5.97 13.334-13.334 13.334c-4.909 0-9.199-2.653-11.514-6.604l-0.034-0.063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M16 21.334l5.334-5.334-5.334-5.334M2.666 16h18.668"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#current",
    style: {
      stroke: "var(--color2, #current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M11.867 10.080c0.413-4.8 2.88-6.76 8.28-6.76h0.173c5.96 0 8.347 2.387 8.347 8.347v8.693c0 5.96-2.387 8.347-8.347 8.347h-0.173c-5.36 0-7.827-1.934-8.267-6.654M2.667 16h17.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#current",
    style: {
      stroke: "var(--color2, #current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M16.867 11.533l4.466 4.467-4.466 4.467"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "help-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 29.333c7.364 0 13.333-5.969 13.333-13.333s-5.969-13.333-13.333-13.333v0c-7.364 0-13.333 5.969-13.333 13.333s5.969 13.333 13.333 13.333v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M12.12 12c0.564-1.569 2.040-2.671 3.773-2.671 2.209 0 4 1.791 4 4 0 0.001 0 0.003 0 0.004v-0c0 2.667-4 4-4 4M16 22.667h0.019"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8M4 8h24M6.666 8l0.8 12.018c0.15 2.23 0.224 3.346 0.59 4.242 0.673 1.625 1.992 2.868 3.628 3.424l0.042 0.012c0.92 0.304 2.038 0.304 4.274 0.304v0c2.236 0 3.354 0 4.272-0.304 1.679-0.568 2.999-1.81 3.657-3.396l0.015-0.040c0.364-0.896 0.44-2.012 0.588-4.242l0.8-12.018"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 4.1665V15.8332",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16669 10H15.8334",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    style: {
      fill: "var(--color1, #161616)"
    },
    d: "M25.6 0h-19.2c-3.535 0-6.4 2.865-6.4 6.4v19.2c0 3.535 2.865 6.4 6.4 6.4h19.2c3.535 0 6.4-2.865 6.4-6.4v-19.2c0-3.535-2.865-6.4-6.4-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.331 23.027c0.244-1.272 0.453-2.61 0.747-3.949 0.145-0.7-0.032-0.999-0.815-0.946s-1.657 0.027-2.49 0c-0.833-0.027-0.982-0.446-0.502-1.044 2.363-2.918 4.753-5.8 7.134-8.674 0.267-0.326 0.575-0.558 1.014-0.312s0.348 0.549 0.276 0.915c-0.263 1.339-0.48 2.677-0.77 3.989-0.149 0.678 0.045 0.919 0.751 0.892 0.709-0.036 1.419-0.036 2.127 0 0.403 0 0.932-0.21 1.141 0.339s-0.231 0.781-0.453 1.106c-0.905 1.115-1.823 2.229-2.752 3.342-1.361 1.624-2.711 3.242-4.051 4.854-0.262 0.317-0.557 0.571-1.005 0.41s-0.353-0.54-0.353-0.924z"
  })), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "logo1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.331 23.027c0.244-1.272 0.453-2.61 0.747-3.949 0.145-0.7-0.032-0.999-0.815-0.946s-1.657 0.027-2.49 0c-0.833-0.027-0.982-0.446-0.502-1.044 2.363-2.918 4.753-5.8 7.134-8.674 0.267-0.326 0.575-0.558 1.014-0.312s0.348 0.549 0.276 0.915c-0.263 1.339-0.48 2.677-0.77 3.989-0.149 0.678 0.045 0.919 0.751 0.892 0.709-0.036 1.419-0.036 2.127 0 0.403 0 0.932-0.21 1.141 0.339s-0.231 0.781-0.453 1.106c-0.905 1.115-1.823 2.229-2.752 3.342-1.361 1.624-2.711 3.242-4.051 4.854-0.262 0.317-0.557 0.571-1.005 0.41s-0.353-0.54-0.353-0.924z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "colors",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 27.296c1.408 1.262 3.278 2.033 5.328 2.033 4.418 0 8-3.582 8-8 0-3.667-2.467-6.758-5.832-7.703l-0.056-0.014M8.56 13.612c-3.418 0.962-5.882 4.052-5.882 7.717 0 4.415 3.575 7.995 7.988 8.004h0.001c0.001 0 0.002 0 0.003 0 4.418 0 8-3.582 8-8 0-1.061-0.207-2.074-0.582-3.001l0.019 0.054M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8v0c0-4.418 3.582-8 8-8s8 3.582 8 8v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "container",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M27.333 9.703l-11.333 6.297M16 16l-11.333-6.297M16 16v12.667M28 21.412v-10.823c0-0.457 0-0.684-0.068-0.889-0.063-0.188-0.16-0.35-0.285-0.486l0.001 0.001c-0.146-0.158-0.347-0.268-0.747-0.491l-9.867-5.481c-0.377-0.21-0.565-0.315-0.764-0.356-0.081-0.017-0.174-0.027-0.269-0.027s-0.188 0.010-0.278 0.029l0.009-0.002c-0.201 0.041-0.391 0.146-0.768 0.356l-9.867 5.481c-0.398 0.222-0.599 0.332-0.745 0.491-0.124 0.135-0.221 0.297-0.282 0.476l-0.003 0.009c-0.068 0.204-0.068 0.432-0.068 0.889v10.823c0 0.457 0 0.684 0.068 0.889 0.063 0.188 0.16 0.35 0.285 0.486l-0.001-0.001c0.146 0.158 0.347 0.268 0.747 0.491l9.867 5.481c0.377 0.21 0.565 0.316 0.764 0.356 0.178 0.037 0.361 0.037 0.539 0 0.201-0.041 0.391-0.146 0.768-0.356l9.867-5.481c0.398-0.222 0.599-0.332 0.745-0.491 0.124-0.135 0.221-0.297 0.282-0.476l0.003-0.009c0.068-0.204 0.068-0.432 0.068-0.889z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M1.333 16s5.333-10.667 14.667-10.667 14.667 10.667 14.667 10.667-5.333 10.667-14.667 10.667-14.667-10.667-14.667-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4v0c-2.209 0-4 1.791-4 4s1.791 4 4 4v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hexagon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.964 3.243c0.379-0.21 0.569-0.315 0.768-0.356 0.081-0.017 0.173-0.027 0.268-0.027s0.188 0.010 0.277 0.029l-0.009-0.002c0.201 0.041 0.391 0.146 0.768 0.356l9.867 5.481c0.398 0.222 0.599 0.332 0.745 0.491 0.124 0.135 0.221 0.297 0.282 0.476l0.003 0.009c0.068 0.204 0.068 0.432 0.068 0.889v10.823c0 0.457 0 0.684-0.068 0.889-0.063 0.188-0.16 0.35-0.285 0.486l0.001-0.001c-0.146 0.158-0.347 0.268-0.747 0.491l-9.867 5.481c-0.377 0.21-0.565 0.316-0.764 0.356-0.081 0.017-0.174 0.027-0.269 0.027s-0.188-0.010-0.278-0.029l0.009 0.002c-0.201-0.041-0.391-0.146-0.768-0.356l-9.867-5.481c-0.398-0.222-0.599-0.332-0.745-0.491-0.124-0.135-0.221-0.297-0.282-0.476l-0.003-0.009c-0.068-0.204-0.068-0.432-0.068-0.889v-10.823c0-0.457 0-0.684 0.068-0.889 0.063-0.188 0.16-0.35 0.285-0.486l-0.001 0.001c0.146-0.158 0.347-0.268 0.747-0.491l9.867-5.481z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "lightning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M18.999 2.667h-7.675c-0.238 0-0.357 0-0.462 0.036-0.098 0.034-0.182 0.087-0.251 0.155l0-0c-0.080 0.078-0.133 0.185-0.24 0.4l-5.6 11.2c-0.256 0.51-0.384 0.766-0.354 0.974 0.029 0.186 0.131 0.345 0.275 0.447l0.002 0.001c0.172 0.121 0.46 0.121 1.031 0.121h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.821-0.853 0.837-1.095 0.001-0.013 0.001-0.028 0.001-0.044 0-0.204-0.091-0.386-0.235-0.508l-0.001-0.001c-0.187-0.158-0.581-0.158-1.371-0.158h-9.49l2.999-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "loading",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.453 22.667c-0.536-0.913-0.853-2.011-0.853-3.183 0-2.183 1.099-4.11 2.775-5.256l0.022-0.014 0.004-0.004c1-0.684 2.235-1.092 3.566-1.092 1.408 0 2.709 0.457 3.764 1.23l-0.018-0.012 4.576 3.328c1.036 0.761 2.337 1.217 3.745 1.217 1.331 0 2.567-0.408 3.589-1.107l-0.022 0.014 0.004-0.002c1.698-1.16 2.797-3.086 2.797-5.269 0-1.173-0.317-2.271-0.871-3.214l0.016 0.030M22.67 27.547c-0.913 0.536-2.010 0.852-3.181 0.852-2.184 0-4.112-1.1-5.258-2.777l-0.014-0.022-0.004-0.004c-0.684-1-1.093-2.236-1.093-3.567 0-1.407 0.457-2.708 1.229-3.763l-0.012 0.018 3.328-4.576c0.761-1.037 1.218-2.338 1.218-3.746 0-1.331-0.408-2.566-1.106-3.588l0.014 0.022-0.005-0.002c-1.161-1.696-3.087-2.795-5.269-2.795-1.172 0-2.271 0.317-3.214 0.87l0.030-0.016M25.428 6.572c2.413 2.413 3.905 5.746 3.905 9.428s-1.492 7.015-3.905 9.428l0-0c-2.413 2.413-5.746 3.905-9.428 3.905s-7.015-1.492-9.428-3.905l0 0c-2.413-2.413-3.905-5.746-3.905-9.428s1.492-7.015 3.905-9.428l-0 0c2.413-2.413 5.746-3.905 9.428-3.905s7.015 1.492 9.428 3.905l-0-0z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "Project",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.309-1.282 1.299-2.272 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.272 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.272-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.272-1.299-2.577-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM4.396 21.644c0.309-1.282 1.299-2.273 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.272 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.195 1.090 0.195 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.273-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.272-1.299-2.577-2.558l-0.005-0.024c-0.124-0.507-0.195-1.090-0.195-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM19.063 6.978c0.309-1.282 1.299-2.272 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.195 1.689-0.195s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.273 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.272-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.195-1.689 0.195s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.273-1.299-2.576-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM19.063 21.644c0.308-1.282 1.299-2.273 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.28 0.3 2.281 1.301 2.581 2.581 0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.308 1.282-1.299 2.273-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.308-2.273-1.299-2.576-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "puzzle-piece",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sprite",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "image",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M25.334 28h1.346c1.296 0 1.942 0 2.3-0.27 0.302-0.23 0.501-0.582 0.526-0.98l0-0.004c0.028-0.446-0.332-0.986-1.050-2.062l-4.014-6.020c-0.594-0.892-0.89-1.336-1.264-1.492-0.151-0.064-0.327-0.102-0.511-0.102s-0.36 0.037-0.52 0.105l0.009-0.003c-0.374 0.156-0.67 0.6-1.264 1.49l-0.992 1.49M25.334 28l-10.246-14.8c-0.59-0.85-0.884-1.276-1.252-1.426-0.149-0.062-0.321-0.098-0.502-0.098s-0.354 0.036-0.511 0.101l0.009-0.003c-0.368 0.15-0.664 0.576-1.252 1.426l-7.93 11.452c-0.75 1.084-1.126 1.626-1.104 2.078 0.020 0.392 0.21 0.756 0.522 0.996 0.36 0.274 1.020 0.274 2.336 0.274h19.93zM28 8c0 2.209-1.791 4-4 4s-4-1.791-4-4v0c0-2.209 1.791-4 4-4s4 1.791 4 4v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.974c0.375 0.978 0.564 1.467 0.857 1.877 0.258 0.364 0.578 0.684 0.942 0.942 0.409 0.293 0.9 0.48 1.877 0.857l6.974 2.683-6.974 2.683c-0.978 0.375-1.467 0.564-1.877 0.857-0.367 0.263-0.679 0.575-0.934 0.93l-0.008 0.012c-0.293 0.409-0.48 0.9-0.857 1.877l-2.683 6.974-2.683-6.974c-0.375-0.978-0.564-1.467-0.857-1.877-0.263-0.367-0.575-0.679-0.93-0.934l-0.012-0.008c-0.409-0.293-0.9-0.48-1.877-0.857l-6.974-2.683 6.974-2.683c0.978-0.375 1.467-0.564 1.877-0.857 0.367-0.263 0.679-0.575 0.934-0.93l0.008-0.012c0.293-0.409 0.48-0.9 0.857-1.877l2.683-6.974z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    style: {
      stroke: "var(--color1, current)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16M8 8l16 16"
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 24h24"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "radioButtonLilac",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#8FA1D0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#8FA1D0"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "radioButtonPink",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#E09CB5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#E09CB5"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "radioButtonGreen",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#BEDBB0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#BEDBB0"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "radioButtonGray",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#B0B0B0"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "project",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.309-1.282 1.299-2.272 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.272 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.272-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.272-1.299-2.577-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM4.396 21.644c0.309-1.282 1.299-2.273 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.272 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.195 1.090 0.195 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.273-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.272-1.299-2.577-2.558l-0.005-0.024c-0.124-0.507-0.195-1.090-0.195-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM19.063 6.978c0.309-1.282 1.299-2.272 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.195 1.689-0.195s1.182 0.071 1.739 0.206l-0.050-0.010c1.282 0.309 2.273 1.299 2.576 2.558l0.005 0.024c0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.309 1.282-1.299 2.272-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.195-1.689 0.195s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.309-2.273-1.299-2.576-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050zM19.063 21.644c0.308-1.282 1.299-2.273 2.558-2.576l0.024-0.005c0.507-0.124 1.090-0.196 1.689-0.196s1.182 0.071 1.739 0.206l-0.050-0.010c1.28 0.3 2.281 1.301 2.581 2.581 0.124 0.507 0.196 1.090 0.196 1.689s-0.071 1.182-0.206 1.739l0.010-0.050c-0.308 1.282-1.299 2.273-2.558 2.576l-0.024 0.005c-0.507 0.124-1.090 0.196-1.689 0.196s-1.182-0.071-1.739-0.206l0.050 0.010c-1.282-0.308-2.273-1.299-2.576-2.558l-0.005-0.024c-0.124-0.507-0.196-1.090-0.196-1.689s0.071-1.182 0.206-1.739l-0.010 0.050z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "time-is-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8c5.523 0 10 4.477 10 10v0c0 0.012 0 0.025 0 0.039 0 0.671-0.073 1.325-0.211 1.954l0.011-0.060 2.2 2.133c0.407-1.212 0.65-2.608 0.667-4.059l0-0.008c0-6.996-5.671-12.667-12.667-12.667v0c-1.482 0.017-2.901 0.26-4.233 0.695l0.1-0.028 2.2 2.2c0.569-0.127 1.223-0.2 1.894-0.2 0.014 0 0.027 0 0.041 0h-0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 3.733c0.325-0.246 0.533-0.632 0.533-1.067 0-0.302-0.1-0.58-0.269-0.803l0.002 0.003c-0.246-0.325-0.632-0.533-1.067-0.533-0.302 0-0.58 0.1-0.803 0.269l0.003-0.002-0.6 0.467 1.933 1.867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.867 3.733l5.333 4c0.212 0.166 0.483 0.267 0.778 0.267 0.008 0 0.016-0 0.023-0l-0.001 0c0.432-0.011 0.815-0.215 1.064-0.53l0.002-0.003c0.166-0.22 0.267-0.498 0.267-0.8 0-0.435-0.208-0.821-0.53-1.064l-0.003-0.002-5.333-4c-0.22-0.166-0.498-0.267-0.8-0.267-0.435 0-0.821 0.208-1.064 0.53l-0.002 0.003c-0.166 0.22-0.267 0.498-0.267 0.8 0 0.435 0.208 0.821 0.53 1.064l0.003 0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4 27.533l-24.933-24.933c-0.232-0.253-0.564-0.41-0.933-0.41s-0.701 0.158-0.933 0.409l-0.001 0.001c-0.253 0.232-0.41 0.564-0.41 0.933s0.158 0.701 0.409 0.932l0.001 0.001 0.867 0.933-0.267 0.2c-0.325 0.246-0.533 0.632-0.533 1.067 0 0.302 0.1 0.58 0.269 0.803l-0.002-0.003c0.252 0.318 0.634 0.523 1.065 0.533l0.002 0c0.007 0 0.014 0 0.022 0 0.294 0 0.565-0.1 0.78-0.269l-0.003 0.002 0.6-0.467 1.733 1.733c-2.345 2.28-3.8 5.465-3.8 8.99 0 0.004 0 0.007 0 0.011v-0.001c0 6.996 5.671 12.667 12.667 12.667v0c0.003 0 0.007 0 0.010 0 3.525 0 6.71-1.455 8.987-3.797l0.003-0.003 2.533 2.533c0.246 0.325 0.632 0.533 1.067 0.533 0.736 0 1.333-0.597 1.333-1.333 0-0.435-0.208-0.821-0.53-1.064l-0.003-0.002zM16 28c-5.523 0-10-4.477-10-10v0c-0-0.014-0-0.031-0-0.048 0-2.779 1.149-5.29 2.998-7.083l0.002-0.002 14.133 14.133c-1.796 1.851-4.306 3-7.085 3-0.017 0-0.034-0-0.051-0h0.003z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.95dc5f19d1d91c96d1de68618b02afe2.svg";
export { ForwardRef as ReactComponent };